module.exports = __webpack_public_path__ + "static/media/icon-filter.dd61f32a.svg";